module.exports = __webpack_public_path__ + "img/rapi-travel-logo.c0a28654.png";